import { campaignState } from "./marketingFormat";

export default function StatusChip({ campaign }) {
  const { label, tone } = campaignState(campaign);
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${tone}`}
    >
      {label}
    </span>
  );
}
